export default __webpack_public_path__ + "static/adac-launch_1_1_en-9e9691f99c48c44804431306363dc796.png";